const SituacaoEnum = {
    ABERTO: 1,
    AGUARDANDO_APROVACAO: 2,
    FINALIZADO: 3
};

export default SituacaoEnum;
